<template>
  <AuthContainer>
    <div class="text-center my-8">
      <h1 class="text-3xl md:text-4xl font-semibold mb-4 text-gray-900">
        {{ $t('auth.resetPasswordOk.title') }}
      </h1>

      <!-- Sous-titre -->
      <p class="text-gray-600 text-lg mb-8">
        {{ $t('auth.resetPasswordOk.subtitle') }}
      </p>

      <!-- Message de confirmation avec style -->
      <div class="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
        <div class="flex items-start space-x-3">
          <svg
            class="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <div class="text-left">
            <h3 class="font-semibold text-green-900 mb-1">
              {{ $t('auth.resetPasswordOk.securityNote.title') }}
            </h3>
            <p class="text-sm text-green-800">
              {{ $t('auth.resetPasswordOk.securityNote.message') }}
            </p>
          </div>
        </div>
      </div>

      <BaseButton width="w-full">
        <router-link append :to="{ name: RoutesKey.AUTH_SIGN_IN }">
          {{ $t('auth.emailVerification.returnToSignIn') }}
        </router-link>
      </BaseButton>
    </div>
  </AuthContainer>
</template>

<script setup lang="ts">
import AuthContainer from './AuthContainer.vue'
import BaseButton from '@/components/ui/BaseButton.vue'
import { RoutesKey } from '@/models/enums/app/RoutesKey'
</script>
